(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;

  /* ---- scroll reveal ---- */
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
  }, {threshold:.08, rootMargin:'0px 0px -6% 0px'});
  document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });

  /* ---- header state ---- */
  var head = document.querySelector('.fb-head'), tick = false;
  function onScroll(){ if(head) head.classList.toggle('stuck', (window.scrollY||0) > 10); tick = false; }
  window.addEventListener('scroll', function(){ if(!tick){ tick = true; requestAnimationFrame(onScroll); } }, {passive:true});
  onScroll();

  /* ---- mobile drawer ---- */
  var burger = document.querySelector('.fb-burger');
  if (burger){
    burger.addEventListener('click', function(){
      var open = document.body.classList.toggle('menu-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
    document.querySelectorAll('.fb-drawer a').forEach(function(a){
      a.addEventListener('click', function(){
        document.body.classList.remove('menu-open');
        document.body.style.overflow = '';
        burger.setAttribute('aria-expanded','false');
      });
    });
    document.addEventListener('keydown', function(ev){
      if (ev.key === 'Escape' && document.body.classList.contains('menu-open')) burger.click();
    });
  }

  /* ---- filter pills ---- */
  var pills = document.querySelectorAll('.fb-pill');
  pills.forEach(function(p){
    p.addEventListener('click', function(){
      pills.forEach(function(x){ x.classList.remove('on'); });
      p.classList.add('on');
      var f = p.dataset.filter || 'all';
      document.querySelectorAll('.fb-card').forEach(function(c, i){
        var tags = (c.dataset.tags || '').split('|');
        var show = (f === 'all') || tags.indexOf(f) > -1;
        c.classList.toggle('hide', !show);
        if (show && !reduce){
          c.style.animation = 'none';
          void c.offsetWidth;
          c.style.animation = 'fbUp .5s cubic-bezier(.22,1,.36,1) ' + (i * 0.05) + 's both';
        }
      });
    });
  });

  /* Wishlist hearts are owned by furbuddy-wish.js — do not bind them here. */

  /* ---- toast ---- */
  var toast = document.querySelector('.fb-toast'), toastTimer;
  function showToast(html){
    if (!toast) return;
    toast.innerHTML = html;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ toast.classList.remove('show'); }, 4200);
  }

  /* ---- add to cart ---- */
  function setCount(n){
    var el = document.querySelector('.fb-cart-count');
    if (!el) return;
    el.textContent = n;
    el.classList.remove('pop');
    void el.offsetWidth;
    el.classList.add('pop');
  }
  document.querySelectorAll('.fb-add-form').forEach(function(form){
    form.addEventListener('submit', function(ev){
      ev.preventDefault();
      var btn = form.querySelector('.fb-add');
      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({ items: [{ id: form.dataset.variant, quantity: 1 }] })
      })
      .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function(){ return fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(function(r){ return r.json(); }); })
      .then(function(cart){
        setCount(cart.item_count);
        btn.textContent = 'Added ✓';
        btn.classList.add('done');
        showToast('Added to your bag · <a href="/cart">View bag</a>');
        setTimeout(function(){ btn.textContent = label; btn.classList.remove('done'); btn.disabled = false; }, 2000);
      })
      .catch(function(){
        btn.textContent = label;
        btn.disabled = false;
        window.location.href = '/cart';
      });
    });
  });

  /* ---- counters ---- */
  var cio = new IntersectionObserver(function(es){
    es.forEach(function(e){
      if (!e.isIntersecting) return;
      var el = e.target;
      cio.unobserve(el);
      var target = parseFloat(el.dataset.count);
      var dec = (el.dataset.dec === '1');
      var suffix = el.dataset.suffix || '';
      if (reduce){ el.textContent = (dec ? target.toFixed(1) : target.toLocaleString('en-US')) + suffix; return; }
      var start = performance.now(), dur = 1400;
      (function tickFn(now){
        var p = Math.min(1, (now - start)/dur), eased = 1 - Math.pow(1-p, 3);
        var v = eased * target;
        el.textContent = (dec ? v.toFixed(1) : Math.round(v).toLocaleString('en-US')) + suffix;
        if (p < 1) requestAnimationFrame(tickFn);
      })(start);
    });
  }, {threshold:.6});
  document.querySelectorAll('[data-count]').forEach(function(el){ cio.observe(el); });

  /* ---- magnetic buttons ---- */
  if (!reduce && fine){
    document.querySelectorAll('.magnetic').forEach(function(el){
      el.addEventListener('mousemove', function(ev){
        var r = el.getBoundingClientRect();
        el.style.transform = 'translate(' + (ev.clientX - r.left - r.width/2)*.18 + 'px,' + (ev.clientY - r.top - r.height/2)*.28 + 'px)';
      });
      el.addEventListener('mouseleave', function(){
        el.style.transition = 'transform .5s cubic-bezier(.22,1,.36,1)';
        el.style.transform = '';
        setTimeout(function(){ el.style.transition = ''; }, 520);
      });
    });
  }

  /* ---- videos: play only while visible ---- */
  var vids = document.querySelectorAll('video[data-lazy]');
  if (vids.length){
    var vio = new IntersectionObserver(function(es){
      es.forEach(function(e){
        var v = e.target;
        if (e.isIntersecting){
          if (v.dataset.src && !v.src){ v.src = v.dataset.src; }
          var p = v.play();
          if (p && p.catch) p.catch(function(){});
        } else {
          v.pause();
        }
      });
    }, {threshold:.15});
    vids.forEach(function(v){ vio.observe(v); });
  }
})();
